/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

// Misc imports
import { WEBPAGE_TITLE_DEFAULT } from '../constants/main';
import { setPageTitle } from '../store/global/globalActions';

/**
 * Adds a title to the browser tab
 */
const DocumentTitle = ({ title }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (document && document.title) {
      document.title = (title && `${title} - ${WEBPAGE_TITLE_DEFAULT}`) || WEBPAGE_TITLE_DEFAULT;
      dispatch(setPageTitle(title));
    }

    return () => {
      // Cleanup
      if (document && document.title) {
        document.title = WEBPAGE_TITLE_DEFAULT;
        dispatch(setPageTitle(WEBPAGE_TITLE_DEFAULT));
      }
    };
  }, [title]);

  return null;
};

DocumentTitle.propTypes = {
  title: PropTypes.string
};

export default DocumentTitle;
